import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import { Grid, useMediaQuery, Box, TAGLink, Accordion, AccordionSummary, AccordionDetails, TAGTypography } from '../../../..';
import { ExpandMore } from '@mui/icons-material';

var ADFooterNavigationContent = function ADFooterNavigationContent(props) {
  var _useState = useState({
    selectedAccordion: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var isADScheduling = props.isADScheduling,
      navigationGroups = props.navigationGroups;
  var isLargeDevice = useMediaQuery('(min-width: 768px)');
  var localDirection = isLargeDevice ? 'row' : 'column';

  var handleChange = function handleChange(accordionId) {
    return function (event, expanded) {
      event.preventDefault();
      setState(_objectSpread(_objectSpread({}, state), {}, {
        selectedAccordion: expanded ? accordionId : ''
      }));
    };
  };

  if (isADScheduling) {
    return React.createElement(React.Fragment, null, navigationGroups.map(function (group) {
      if (group.navigationGroupLink.breadcrumbTitle === 'Company' || group.navigationGroupLink.title === 'Company') {
        var navigationLinks = group.navigationLinksForGroup;
        return React.createElement(Grid, {
          item: true,
          container: true,
          alignItems: "center",
          justifyContent: "center",
          spacing: isLargeDevice ? 7 : 3,
          direction: localDirection,
          key: group.navigationGroupLink.id
        }, navigationLinks.map(function (navigationLink) {
          if (navigationLink.breadcrumbTitle === 'Accessibility' || navigationLink.breadcrumbTitle === 'Privacy Policy' || navigationLink.breadcrumbTitle === 'Terms of Use') {
            return React.createElement(Grid, {
              item: true,
              key: navigationLink.id
            }, React.createElement(TAGLink, {
              href: navigationLink.path,
              underline: "always",
              color: "neutrals.white"
            }, navigationLink.breadcrumbTitle));
          } else {
            return null;
          }
        }));
      } else {
        return null;
      }
    }));
  } else {
    return isLargeDevice ? React.createElement(Box, {
      sx: {
        display: 'grid',
        width: '100%',
        gridTemplateColumns: "repeat(".concat(navigationGroups.length, ", 5fr)"),
        gridColumnGap: '15px',
        overflow: 'hidden'
      }
    }, navigationGroups.map(function (group) {
      return React.createElement(Grid, {
        item: true,
        key: group.navigationGroupLink.id
      }, React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 2
      }, React.createElement(Grid, {
        item: true,
        key: group.navigationGroupLink.id
      }, React.createElement(TAGLink, {
        href: group.navigationGroupLink.path,
        color: "neutrals.white",
        variant: "bodyLargeBold"
      }, group.navigationGroupLink.breadcrumbTitle || group.navigationGroupLink.title)), group.navigationLinksForGroup.map(function (navigationItem) {
        return React.createElement(Grid, {
          item: true,
          key: navigationItem.id
        }, React.createElement(TAGLink, {
          href: navigationItem.path,
          color: "neutrals.white"
        }, navigationItem.breadcrumbTitle || navigationItem.title));
      })));
    })) : React.createElement(Grid, {
      item: true,
      container: true,
      direction: "column",
      spacing: 1
    }, navigationGroups.map(function (group) {
      return React.createElement(Grid, {
        item: true,
        key: group.navigationGroupLink.id
      }, React.createElement(Accordion, {
        key: group.navigationGroupLink.id,
        sx: {
          backgroundColor: 'backgrounds.dark',
          boxShadow: 'none'
        },
        onChange: handleChange(group.navigationGroupLink.id),
        expanded: state.selectedAccordion === group.navigationGroupLink.id
      }, React.createElement(AccordionSummary, {
        sx: {
          '&.MuiAccordionSummary-root': {
            padding: 0
          }
        },
        expandIcon: React.createElement(ExpandMore, {
          fontSize: "large",
          sx: {
            color: 'text.light'
          }
        })
      }, React.createElement(TAGTypography, {
        variant: "bodyLargeBold",
        sx: {
          color: 'text.light',
          justifyContent: 'flex-start',
          lineHeight: '24px'
        }
      }, group.navigationGroupLink.breadcrumbTitle || group.navigationGroupLink.title)), React.createElement(AccordionDetails, null, React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 2,
        sx: {
          paddingLeft: '5px'
        }
      }, group.navigationLinksForGroup.map(function (navigationItem) {
        return React.createElement(Grid, {
          item: true,
          key: navigationItem.id
        }, React.createElement(TAGLink, {
          href: navigationItem.path,
          color: "text.light"
        }, navigationItem.breadcrumbTitle || navigationItem.title));
      })))));
    }));
  }
};

export default ADFooterNavigationContent;